import annaprasana_background from "../images/annaprasana/annaprasana_background.png";
import annaprasana1 from "../images/annaprasana/annaprasana1.png";
import annaprasana2 from "../images/annaprasana/annaprasana2.png";

export const annaprasanaslides = [

/* ---------------- 👶 SLIDE 1 — ANNAPRASANA INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: annaprasana_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 25,
    type: "image",
    src: annaprasana1,
    x:150,
    y: 330,
    width: 300,
    height: 400,
    shape: "circle",
    stroke: "#e095a5",
    strokeWidth: 2
  },

  {
    id: 2,
    type: "text",
    text: "👶 Annaprasana Ceremony 👶",
    x: 110,
    y: 100,
    fontSize: 25,
    fontFamily: "Poppins",
    fill: "#e095a5",
  },

  {
    id: 4,
    type: "text",
    text: "Celebrating Baby’s First Rice Feeding",
    x: 110,
    y: 250,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 5,
    type: "text",
    text: "Join us with love and blessings on this joyful occasion",
    x: 120,
    y: 280,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

],


/* ---------------- 👶 SLIDE 2 — ANNAPRASANA DETAILS ---------------- */
[
  {
    id: 8,
    type: "background",
    src: annaprasana_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 26,
    type: "image",
    src: annaprasana2,
    x:100,
    y: 400,
    width: 200,
    height: 300,
    shape: "circle",
    stroke: "#e095a5",
    strokeWidth: 2
  },

  {
    id: 10,
    type: "text",
    text: "💖 You're Invited 💖",
    x: 210,
    y: 240,
    fontSize: 23,
    fontFamily: "Open Sans",
    fill: "#e095a5"
  },

  {
    id: 11,
    type: "text",
    text: "📅 18 July 2026",
    x: 230,
    y: 265,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 12,
    type: "text",
    text: "⏰ 10:30 AM",
    x: 240,
    y: 290,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 13,
    type: "text",
    text: "📍 Sri Lakshmi Function Hall, Vijayawada",
    x: 180,
    y: 315,
    fontSize: 12,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 14,
    type: "text",
    text: "Blessings • Love • Happiness",
    x: 280,
    y: 410,
    fontSize: 17,
    fontFamily: "Open Sans",
    fill: "#e095a5"
  },

  {
    id: 15,
    type: "text",
    text: "Your presence will make this special day",
    x: 290,
    y: 450,
    fontSize: 11,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 20,
    type: "text",
    text: "even more memorable for our family",
    x: 300,
    y: 490,
    fontSize: 11,
    fontFamily: "Poppins",
    fill: "#e095a5"
  },

  {
    id: 28,
    type: "text",
    text: "Contact:7930xxxxx",
    x: 260,
    y: 570,
    fontSize: 26,
    fontFamily: "Dancing Script",
    fill: "#e095a5"
  }
]

];